module.exports = __webpack_public_path__ + "static/img/jsg.74a19fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/jsg.jpg
// module id = dWNy
// module chunks = 0